import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { isNewbuildingFromBuilderSelector, isNewbuildingFromSellerSelector } from 'shared/selectors';
import { selectNewbuildingBrokerOfferBookingEnabled } from 'shared/selectors/featureToggle';
import { selectIsChatsEnabled } from 'shared/selectors/offerChat';

import { ChatOnboardingContainer } from '../../ChatOnboardingContainer';
import { SendMessageButtonContainer } from '../SendMessageButton';

interface INewbuildingMessageButtonContainerProps {
  isPhonesOpened: boolean;
}

export const NewbuildingMessageButtonContainer: React.FC<INewbuildingMessageButtonContainerProps> = ({
  isPhonesOpened,
}) => {
  const isChatsEnabled = useSelector(selectIsChatsEnabled);
  const isNewbuildingFromBuilder = useSelector(isNewbuildingFromBuilderSelector);
  const isNewbuildingFromSeller = useSelector(isNewbuildingFromSellerSelector);
  const offerBookingEnabled = useSelector(selectNewbuildingBrokerOfferBookingEnabled);

  const isNewbuildingFromDeveloper = isNewbuildingFromBuilder || isNewbuildingFromSeller;

  if (!isChatsEnabled || !isNewbuildingFromDeveloper) {
    return null;
  }

  // TODO: В CD-235461 после запуска проекта бронирования удалить этот рендер кнопки.
  if (!offerBookingEnabled) {
    return (
      <ChatOnboardingContainer type="builder">
        <SendMessageButtonContainer
          title={isNewbuildingFromBuilder ? 'Написать застройщику' : 'Написать представителю'}
        />
      </ChatOnboardingContainer>
    );
  }

  if (isPhonesOpened) {
    return <SendMessageButtonContainer title="Написать в чат" theme="fill_primary" noMarginTop />;
  }

  return (
    <ChatOnboardingContainer type="builder" placement="top-end" minWidth="160px">
      <SendMessageButtonContainer
        title={null}
        theme="fill_primary"
        ariaLabel="Написать застройщику"
        beforeIcon={<IconCommunicationMessage16 color="icon-inverted-default" />}
        noMarginTop
      />
    </ChatOnboardingContainer>
  );
};
